import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { BookUser, Save, Trash2, Loader2 } from "lucide-react";

const GOLD = "#C9A84C";

export function BuyerBook({ api, recipient, onPick, refreshKey }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/billdesk/buyers").then((r) => setRows(r.data.buyers)).catch(() => {}), [api]);
  useEffect(() => { load(); }, [load, refreshKey]);
  const pick = (id) => { const b = rows.find((x) => x.id === id); if (b) { onPick({ name: b.name, gstin: b.gstin, pan: b.pan || "", address: b.address, state: b.state, contact: b.contact }); toast(`Buyer loaded · ${b.name}`); } };
  const save = async () => {
    setBusy(true);
    try { const r = await api.post("/billdesk/buyers", recipient); toast.success(`Saved to address book · ${r.data.name}`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not save buyer"); }
    finally { setBusy(false); }
  };
  const remove = async (b) => { try { await api.delete(`/billdesk/buyers/${b.id}`); toast(`Removed ${b.name}`); load(); } catch { toast.error("Could not remove"); } };
  const current = rows.find((b) => (b.gstin && b.gstin === (recipient.gstin || "").toUpperCase()) || (!b.gstin && b.name.toLowerCase() === (recipient.name || "").toLowerCase()));
  return (
    <div className="mt-2 border border-white/10 bg-black/30 p-3" data-testid="buyer-book">
      <div className="flex flex-wrap items-center gap-2">
        <BookUser size={12} style={{ color: GOLD }} />
        <span className="font-grotesk text-[8px] uppercase tracking-[0.26em] text-[#8A8A82]">Address book · {rows.length} saved</span>
        <select data-testid="buyer-book-select" className="ml-auto bg-black/50 border border-white/15 px-2 py-1 text-[11px] text-[#F5F5F0] max-w-[220px]" value="" onChange={(e) => pick(e.target.value)}>
          <option value="">{rows.length ? "Load a saved buyer…" : "No buyers saved yet"}</option>
          {rows.map((b) => <option key={b.id} value={b.id}>{b.name}{b.gstin ? ` · ${b.gstin}` : ""}</option>)}
        </select>
        <button data-testid="buyer-book-save" onClick={save} disabled={busy || !recipient.name} title="Save this buyer for next time" className="inline-flex items-center gap-1 border px-2.5 py-1 font-grotesk text-[8px] uppercase tracking-[0.2em] disabled:opacity-40" style={{ color: GOLD, borderColor: `${GOLD}66` }}>
          {busy ? <Loader2 size={10} className="animate-spin" /> : <Save size={10} />} {current ? "Update" : "Save buyer"}
        </button>
        {current && <button data-testid="buyer-book-remove" onClick={() => remove(current)} title="Remove from address book" className="text-[#8A8A82] hover:text-[#E07070]"><Trash2 size={12} /></button>}
      </div>
      {current && <div className="mt-1.5 font-mono text-[10px] text-[#8A8A82]" data-testid="buyer-book-current">On file · used {current.uses || 0}× · updated {new Date(current.updated_at).toLocaleDateString("en-IN")}</div>}
    </div>
  );
}
